export default __webpack_public_path__ + "static/media/logoIcon.a868ebaf.svg";